import AsyncStorage from "@react-native-async-storage/async-storage";
import { create as _create } from "zustand";
import type { StateCreator } from "zustand";
import { AsyncStorageKeys } from "utils/asyncStorageKeys";

// Two separate sets for resettable and persistent stores
const resettableStores = new Set<() => void>();

export const resetAllStores = () => {
  resettableStores.forEach((resetFn) => {
    resetFn();
  });
  AsyncStorage.removeItem(AsyncStorageKeys.codeApplied);
};

// Regular create function for stores that SHOULD be reset
export const create = (<T>() => {
  return (stateCreator: StateCreator<T>) => {
    const store = _create(stateCreator);
    const initialState = store.getState();

    // Add reset function to the set
    resettableStores.add(() => {
      store.setState(initialState, true);
    });

    return store;
  };
}) as typeof _create;

// Separate create function for stores that should NOT be reset
export const createPersistent = (<T>() => {
  return (stateCreator: StateCreator<T>) => {
    // Just create a store without adding reset function
    return _create(stateCreator);
  };
}) as typeof _create;
